import { useCallback } from 'react';

import { Trash } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import ConfirmationPopover from '@/components/ConfirmationPopover';
import { APP_PREFIX } from '@/utils/constants';
import { useAppAlert } from '@Components/AppAlert';
import DeleteConfirmationContent from '@Components/DeleteConfirmationContent';
import { useGrid } from '@Components/Grid';
import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function DeleteEntryWithReferences({ info, asLabel }) {
  const { row } = getInfo(info)
  const { definitions: { entityName }, events: { handleDeleteEntry }, store: { getReferences } } = useGrid()
  const { handleSuccess } = useAppAlert()

  const handleSubmit = useCallback(async () => {
    await handleDeleteEntry(row)
    handleSuccess(`${entityName} deleted!`)
  }, [row, handleDeleteEntry, handleSuccess, entityName])

  const loadReferences = useCallback(async () => {
    const data = await getReferences(row.id)
    const references = {}

    if (!data) {
      return references
    }

    const offers = data.offers?.map(({ id, name, site_id }) => ({ id, description: name, url: `${APP_PREFIX}/offer/offers/${id}`, site_id }))

    if (offers.length) {
      references.offers = offers
    }

    return references
  }, [row, getReferences])

  const target = asLabel ? <span>Delete</span> : <DefaultTooltip content='Delete'><Trash size={16} /></DefaultTooltip>

  return <>
    <ConfirmationPopover
      target={target}
      title={<span>Delete {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.title}`}</i></span>}
    >
      <DeleteConfirmationContent origin="post" loadReferences={loadReferences} action={handleSubmit} />
    </ConfirmationPopover>
  </>
}
